export default {

    data() {
        return {
            searchValue: '',
            Headers: [{
                text: "Name",
                value: "name",
                sortable: true
            },
            {
                text: "Postion",
                value: "Postion",
                sortable: true
            },
            {
                text: "Salary",
                value: "Salry",
                sortable: true
            },

            {
                text: "Office",
                value: "Office",
                sortable: true
            },
            {
                text: "Skill",
                value: "Skill",
                sortable: true
            },
            {
                text: "Extn",
                value: "Extn",
                sortable: true
            },
            {
                text: "Email",
                value: "Email",
                sortable: true
            },
            ],
            Item: [{
                name: "Airi Satou",
                avator: require('@/assets/images/user/5.jpg'),
                Postion: "Accountant",
                Salry: '$162,700',
                Office: 'Tokyo',
                Extn: "5407",
                Email: "a.satou@datatables.net",
                classe: 'bg-sucess',
                widthe: '70%'
            },
            {
                name: "Asthon Cox ",
                Postion: "Junior Technical Author",
                Salry: '$86,000',
                Office: 'San Franscio',
                avator: require('@/assets/images/user/3.jpg'),
                Extn: "1562",
                Email: "a.cox@datatables.net",
                classe: 'bg-danger',
                widthe: '60%'
            },
            {
                name: "Bardley Greer",
                Postion: "Software Engineer",
                Salry: '$132,000',
                Office: 'London',
                avator: require('@/assets/images/user/7.jpg'),
                Extn: "2558",
                Email: "b.greer@datatables.net",
                classe: 'bg-primary',
                widthe: '30%',
            },
            {
                name: "Brielle Williamson",
                Postion: "Integration Specialist",
                Salry: '$372,700',
                Office: 'New York',
                avator: require('@/assets/images/user/6.jpg'),
                Extn: "4804",
                Email: "b.williamson@datatables.net",
                classe: 'bg-info',
                widthe: '55%'
            },
            {
                name: "Caesar Vance",
                Postion: "Pre-Sales Support",
                Salry: '$106,450',
                Office: 'Tokyo',
                avator: require('@/assets/images/user/11.png'),
                Extn: "8330",
                Email: "c.vance@datatables.net",
                classe: 'bg-success',
                widthe: '50%'
            },
            {
                name: "Cedric Kelly",
                Postion: "Senior Javascript Developer",
                Salry: '$433,060',
                Office: 'Edinburgh',
                avator: require('@/assets/images/user/4.jpg'),
                Extn: "6224",
                Email: "c.kelly@datatables.net",
                classe: 'bg-secondary',
                widthe: '80%'
            },
            {
                name: "Charde Marshall",
                Postion: "Regional Director",
                Salry: '$470,600	',
                Office: 'San Francisco',
                avator: require('@/assets/images/user/1.jpg'),
                Extn: "6741",
                Email: "c.marshall@datatables.net",
                classe: 'bg-info',
                widthe: '100%'
            },
            {
                name: "Colleen Hurst",
                Postion: "Javascript Developer",
                Salry: '$205,500',
                Office: 'Tokyo',
                avator: require('@/assets/images/user/9.jpg'),
                Extn: "2306",
                Email: "c.hurst@datatables.net",
                classe: 'bg-success',
                widthe: '20%'
            },
            {
                name: "Dai Rios",
                Postion: "Personnel Lead",
                Salry: '$217,700',
                Office: 'Edinburgh',
                avator: require('@/assets/images/user/8.jpg'),
                Extn: "2290",
                Email: "d.rios@datatables.net",
                classe: 'bg-warning',
                widthe: '40%'
            },
            {
                name: "Garrett Winters",
                Postion: "Accountant",
                Salry: '$170,150',
                Office: 'Tokyo',
                avator: require('@/assets/images/user/2.png'),
                Extn: "3308",
                Email: "g.winters@datatables.net",
                classe: 'bg-secondary',
                widthe: '70%'
            },
            {
                name: "Gloria Little",
                Postion: "Systems Administrator",
                Salry: '$237,500',
                Office: 'New York',
                avator: require('@/assets/images/user/6.jpg'),
                Extn: "1721",
                Email: "a.satou@datatables.net",
                classe: 'bg-sucess',
                widthe: '10%'
            },
            {
                name: "Haley Kennedy",
                Postion: "Senior Marketing Designer",
                Salry: '$313,500',
                Office: 'London',
                avator: require('@/assets/images/user/2.png'),
                Extn: "6407",
                Email: "h.kennedy@datatables.net",
                classe: 'bg-success',
                widthe: '55%'
            },
            {
                name: "Jenette Caldwell",
                Postion: "Development Lead",
                Salry: '$345,000',
                Office: 'New York',
                avator: require('@/assets/images/user/9.jpg'),
                Extn: "5437",
                Email: "j.satou@datatables.net",
                classe: 'bg-info',
                widthe: '45%'
            },
            {
                name: "Quinn Flynn",
                Postion: "Support Lead",
                Salry: '$342,002',
                Office: 'Edinburg',
                avator: require('@/assets/images/user/12.png'),
                Extn: "2407",
                Email: "q.flynn@datatables.net",
                classe: 'bg-danger',
                widthe: '60%'
            },
            ]
        }
    },

}